import {Controller} from '@hotwired/stimulus';
import axios from "axios";
import {getMeta} from "../helpers";

export default class extends Controller {
    static targets = ["offerCode", "offerCodeWarning", "hiddenContent", "type", "bankDetails",
        "goToCheckoutBtn", "takeoverMembershipBtn", "debitMembershipNotes", "cashMembershipNotes", "paySum"]

    static values = {checkCodeUrl: String}

    connect() {
        this.currentLanguageCode = getMeta('wp-language').split('-')[0];
        this.toggleContent()
    }

    disconnect() {
        clearTimeout(this.checkCodeTimeout);
    }

    get offerCode() {
        return this.offerCodeTarget.value.trim();
    }

    toggleContent() {
        const offerCode = this.offerCode;

        // Input also fires on changes that don't affect the code, e.g. a trailing space
        if (offerCode === this.lastOfferCode) {
            return;
        }

        this.lastOfferCode = offerCode;

        const type = /^\d{3,7}-\d{3,7}$/.test(offerCode) ? "DEBIT" : offerCode.length === 32 ? "CASH" : null;

        clearTimeout(this.checkCodeTimeout);
        this.clearOfferCodeMessages();
        this.hiddenContentTargets.forEach(element => element.classList.add("d-none"));
        this.typeTarget.value = "";

        if (type) {
            this.checkCodeTimeout = setTimeout(() => this.checkOfferCode(offerCode, type), 400);
        }
    }

    checkOfferCode(offerCode, type) {
        const url = this.checkCodeUrlValue + '?rest_language=' + this.currentLanguageCode;
        const formData = new FormData();
        formData.append('offer_code', offerCode);

        axios.post(url, formData)
            .then(response => response.data.data)
            // If the check itself fails, let the user continue, the code is validated again on submit
            .catch(() => null)
            .then(response => {
                if (offerCode !== this.offerCode) {
                    return;
                }

                if (response?.errors?.offer_code) {
                    this.showOfferCodeError(response.errors.offer_code);
                    return;
                }

                if (response?.warning) {
                    this.offerCodeWarningTarget.textContent = response.warning;
                    this.offerCodeWarningTarget.classList.remove('d-none');
                }

                this.hiddenContentTargets.forEach(element => element.classList.remove("d-none"));
                this.updateMembershipType(type);
            });
    }

    showOfferCodeError(message) {
        const messageNode = document.createElement('span');
        messageNode.classList.add('input-error');
        messageNode.textContent = message;

        this.offerCodeTarget.classList.add('invalid');
        this.offerCodeTarget.after(messageNode);
    }

    clearOfferCodeMessages() {
        this.offerCodeTarget.classList.remove('invalid');
        this.offerCodeTarget.parentNode.querySelectorAll('.input-error').forEach(element => element.remove());
        this.offerCodeWarningTarget.classList.add('d-none');
    }

    updateMembershipType(type) {
        this.typeTarget.value = type;

        if (type === "DEBIT") {
            this.bankDetailsTarget.classList.remove('d-none');
            this.goToCheckoutBtnTarget.classList.remove('d-none');
            this.takeoverMembershipBtnTarget.classList.add('d-none');
            this.debitMembershipNotesTarget.classList.remove('d-none');
            this.cashMembershipNotesTarget.classList.add('d-none');
            this.paySumTarget.classList.remove('d-none');
        } else if (type === "CASH") {
            this.bankDetailsTarget.classList.add('d-none');
            this.goToCheckoutBtnTarget.classList.add('d-none');
            this.takeoverMembershipBtnTarget.classList.remove('d-none');
            this.debitMembershipNotesTarget.classList.add('d-none');
            this.cashMembershipNotesTarget.classList.remove('d-none');
            this.paySumTarget.classList.add('d-none');
        }
    }
}
